<template>
  <van-popup
    v-model="visible"
    v-bind="$attrs"
    class="common_popup"
    :style="{
      height: styleHeight
    }"
    v-on="$listeners"
  >
    <header v-if="title" class="common_popup_title">
      <slot v-if="$slots.title" name="title" />
      <span v-else>
        {{ title }}
      </span>
    </header>
    <div class="common_popup_main">
      <slot />
    </div>
    <footer v-if="showFooter" class="common_popup_footer">
      <slot v-if="$slots.footer" name="footer" />
      <div v-else class="common_popup_footer_wrapper">
        <span v-if="showCancel" @click="cancel">取消</span>
        <span
          class="primary"
          :class="{
            disabled: confirmDisabled,
          }"
          @click="confirm"
        >
          {{ confirmText }}
        </span>
      </div>
    </footer>
  </van-popup>
</template>

<script>
export default {
  props: {
    value: Boolean,
    title: String,
    height: [Number, String],
    confirmText: {
      type: String,
      default: '确定',
    },
    confirmDisabled: Boolean,
    showFooter: {
      type: Boolean,
      default: true,
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    styleHeight () {
      const { height } = this
      return height ? (typeof height === 'number' ? `${height}px` : height) : '79.8%'
    }
  },
  methods: {
    cancel() {
      this.visible = false
      this.$emit('click-overlay')
    },
    confirm() {
      if (this.confirmDisabled) {
        return
      }
      this.$emit('confirm')
    },
  },
}
</script>

<style lang="less">
@import '~@/common/style/variables.less';
.common_popup {
  display: flex;
  flex-direction: column;
  & .common_popup_title {
    padding: 11px 16px;
    font-size: 16px;
    line-height: 24px;
    font-weight: bold;
    font-weight: 500;
    text-align: center;
    & > span {
      .nowrap;
      width: 100%;
      padding: 0 2em;
      white-space: nowrap;
      box-sizing: border-box;
    }
  }
  & .common_popup_main {
    position: relative;
    flex: 1;
    overflow: auto;
    min-height: 0;
  }
  & .common_popup_footer {
    .safeAreaInsetBottom;
    font-size: 14px;
    line-height: 1.2;
    text-align: center;
    border-top: 1px solid var(--primary-color-border);
    background: var(--minor-color-bg);
    & .common_popup_footer_wrapper {
      display: flex;
      padding: 7px 15px;
      & > span {
        flex: 1;
        display: inline;
        line-height: 100%;
        padding: 10px 16px;
        color: var(--primary-color-text);
        border: 1px solid var(--assist-color-text);
        border-radius: 6px;
      }
      & > span:not(:last-child) {
        margin-right: 9px;
      }
      & > span.primary {
        color: white;
        background: var(--primary-color);
        border-color: var(--primary-color);
      }
      & > span.disabled {
        color: white;
        background: var(--patch-color-text);
        border-color: var(--patch-color-text);
      }
    }
  }
}
</style>
